// 环境配置
export const ENV_CONFIG = {
  local: {
    name: '本地环境',
    apiBaseUrl: 'http://localhost:6380/api/v1',
    tokenKey: 'local_token'
  },
  cn: {
    name: '中国站',
    apiBaseUrl: 'https://backend.app.petsnowy.com/api/v1',
    tokenKey: 'cn_token'
  },
  global: {
    name: '海外站',
    apiBaseUrl: 'https://backend-global.app.petsnowy.com/api/v1',
    tokenKey: 'global_token'
  }
}

// 获取当前环境
export const getCurrentEnv = () => {
  return localStorage.getItem('currentEnv') || 'cn'
}

// 设置当前环境
export const setCurrentEnv = (env) => {
  localStorage.setItem('currentEnv', env)
}

// 获取当前环境配置
export const getCurrentEnvConfig = () => {
  return ENV_CONFIG[getCurrentEnv()]
}

// 获取当前环境的 API 基础地址
export const getApiBaseUrl = () => {
  return getCurrentEnvConfig().apiBaseUrl
} 